<!-- 添加打印资料内容 -->
<template>
  <el-dialog
    :title="title"
    width="750"
    :visible="addVisible"
    :before-close="handleCancel">
    <!-- <el-spin :spinning="confirmLoading"> -->
      <el-form >
        <el-form-item label="内容名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <el-input v-model="input1" placeholder="例如：考试官"></el-input>
        </el-form-item>
        <el-form-item label="内容信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <el-input v-model="input2" placeholder="例如：张三"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit()">确 定</el-button>
      </div>
    <!-- </el-spin> -->
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      title: '添加资料内容',
      addVisible: false,
      labelCol: { lg: { span: 4 }, sm: { span: 17 } },
      wrapperCol: { lg: { span: 17 }, sm: { span: 10 } },
      // form: this.$form.createForm(this),
      input1: '',
      input2: ''
    }
  },
  methods: {
    show () {
      this.addVisible = true
    },
    handleSubmit () {
      // this.adLoading = true
      if (this.input1 === '') {
        this.$message.warning('请输入内容名称')
        return false
      } else if (this.input2 === '') {
        this.$message.warning('请输入内容信息')
        return false
      }
      this.$emit('addPrintDataSuccess', this.input1, this.input2)
      this.addVisible = false
      this.input1 = ''
      this.input2 = ''
    },
    handleCancel () {
      this.input1 = ''
      this.input2 = ''
      this.addVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/UserCenter/AddPrintCertData.vue